const Button: React.FC<IPropsButton> = ({
  className,
  onClick,
  type = "button",
  prefixIcon,
  postfixIcon,
  children,
  variant,
  disabled,
  ...props
}) => {
  const baseStyles =
    "px-4 py-2 rounded-[10px] text-white focus:outline-none transition duration-150 ease-in-out";
  const greenVariantStyles = !disabled
    ? "bg-green2 hover:bg-green1 text-wht active:bg-green3"
    : "bg-green4 cursor-not-allowed text-wht";

  const pinkVariantStyles = !disabled
    ? "bg-pink2 hover:bg-pink1 text-wht active:bg-pink3"
    : "bg-pink4 cursor-not-allowed text-wht";

  const blueVariantStyles = !disabled
    ? "bg-blue2 rounded-[10px] hover:bg-blue1 active:bg-blue3"
    : "bg-blue4 cursor-not-allowed";

  const grayVariantStyles = !disabled
    ? "border border-gray5 rounded-[10px] !text-gray3 hover:border-gray3 active:border-trasparent hover:!text-gray2  active:!text-black1 active:bg-gray6"
    : "bg-gray6 text-gray5 cursor-not-allowed";

  const slimeVariantStyles = !disabled
    ? "bg-slime2 hover:bg-slime1 active:bg-slime3"
    : "bg-slime4 cursor-not-allowed";

  // slime: "bg-slime4 hover:bg-slime3 active:bg-slime2",
  const variantStyles =
    variant === "green"
      ? greenVariantStyles
      : variant === "blue"
      ? blueVariantStyles
      : variant === "pink"
      ? pinkVariantStyles
      : variant === "gray"
      ? grayVariantStyles
      : variant === "slime"
      ? slimeVariantStyles
      : "";

  return (
    <button
      type={type}
      className={`${baseStyles} ${variantStyles} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...props}>
      <div className="flex items-center justify-between">
        {prefixIcon ? (
          <span>{prefixIcon}</span>
        ) : (
          <div className="invisible">ed</div>
        )}
        <div className="w-full">{children}</div>
        {postfixIcon ? (
          <span className="ml-2">{postfixIcon}</span>
        ) : (
          <div className="invisible">ed</div>
        )}
      </div>
    </button>
  );
};

export default Button;
